import React from 'react';

import { TopBar } from '@xingternal/top-bar';
import { GridContainer } from '@xingternal/xing-grid';

import { routes } from '@/config';
import { useBreakpoints, useLoginStates, useLoginUrl } from '@/hooks';

import * as S from './job-application-xing-frame.styles';

export type JobApplicationTrackingStatus = 'loading_error' | 'loading' | 'error' | 'confirmation' | 'form';

type JobApplicationXingFrameProps = {
  jobApplicationTrackingStatus: JobApplicationTrackingStatus;
};

const propActionOriginFromStatus: Record<JobApplicationTrackingStatus, string> = {
  loading_error: 'jobs_apply_loading_error',
  loading: 'jobs_apply_loading',
  error: 'jobs_apply_form_submit_error',
  confirmation: 'jobs_apply_form_submitted',
  form: 'jobs_apply_form',
};

export const JobApplicationXingFrame: React.FC<JobApplicationXingFrameProps> = ({
  children,
  jobApplicationTrackingStatus,
}) => {
  const loginUrl = useLoginUrl();
  const { isLoggedIn } = useLoginStates();
  const { isMobile } = useBreakpoints();

  const signUpBaseLink = `${routes.signup}?signup_channel=jobs_apply_form&sc_o=jobs_apply_header_register`;

  const signUpLink = `${signUpBaseLink}${`&sc_o_PropActionOrigin=${propActionOriginFromStatus[jobApplicationTrackingStatus]}`}`;

  return isLoggedIn ? (
    <S.ZenView withSubNav={isMobile}>
      {isMobile ? <TopBar type="logo" /> : null}
      <GridContainer>{children}</GridContainer>
    </S.ZenView>
  ) : (
    <S.LoggedOutView loginLink={loginUrl} signupLink={signUpLink} hideQuickLinks={true}>
      {children}
    </S.LoggedOutView>
  );
};
